declare global {
  interface Window {
    MSStream?: any;
  }
}

export const isiOSDevice = () => {
  if (navigator?.platform?.toUpperCase().indexOf('MAC') >= 0) {
    return false;
  }
  return (
    navigator.vendor === 'Apple Computer, Inc.' ||
    (/iPad|iPhone|iPod/.test(navigator.userAgent) &&
      !window.MSStream &&
      ('ontouchend' in document || navigator.maxTouchPoints > 1))
  );
};
